import piction from './piction';
import appConfig from "../appConfig";

export const BASE_KAUIFUNC_URL = `${appConfig.cardURL}/kauifunc`;
const RUN_PUBLISH_URL = `${BASE_KAUIFUNC_URL}/taskrun`;

export const runPublish = (intl) => {
    return $.post(RUN_PUBLISH_URL,
      { run: true, surl: piction.session.surl ? piction.session.surl : undefined, csrftoken: piction.session._token })
}



// WEBPACK FOOTER //
// ./src/js/utils/xtrafunc.js